import PropTypes from "prop-types";
import { useState } from "react";

const ShortenedText = ({ text }) => {
  const [isHovered, setIsHovered] = useState(false);

  if (!text || text.length < 9) return text;

  const shortened = `${text.slice(0, 4)}...${text.slice(-4)}`;

  return (
    <span
      className="relative group cursor-pointer hover:underline"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {shortened}
      {isHovered && (
        <div
          className="fixed z-[9999] transform -translate-x-1/2 px-2 py-1 bg-gray-800 text-white text-xs rounded whitespace-nowrap shadow-lg"
          style={{
            top: `${window.scrollY + window.event.clientY - 30}px`,
            left: `${window.event.clientX}px`,
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {text}
          <button
            className="ml-2 text-blue-300 hover:text-blue-100"
            onClick={(e) => {
              e.stopPropagation();
              navigator.clipboard.writeText(text);
            }}
          >
            Copy
          </button>
        </div>
      )}
    </span>
  );
};

ShortenedText.propTypes = {
  text: PropTypes.string.isRequired,
};

export default ShortenedText;
